import { Component } from '@angular/core';

@Component({
  selector: 'app-top-profile',
  imports: [],
  templateUrl: './top-profile.component.html',
  styleUrl: './top-profile.component.scss'
})
export class TopProfileComponent {

}
